/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TriggerKind = {
    MessageAddedToConversation: 'MESSAGE_ADDED_TO_CONVERSATION',
    ConversationCreated: 'CONVERSATION_CREATED',
    ConversationDataChanged: 'CONVERSATION_DATA_CHANGED'
} as const;
export type TriggerKind = typeof TriggerKind[keyof typeof TriggerKind];


export function instanceOfTriggerKind(value: any): boolean {
    for (const key in TriggerKind) {
        if (Object.prototype.hasOwnProperty.call(TriggerKind, key)) {
            if (TriggerKind[key as keyof typeof TriggerKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TriggerKindFromJSON(json: any): TriggerKind {
    return TriggerKindFromJSONTyped(json, false);
}

export function TriggerKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerKind {
    return json as TriggerKind;
}

export function TriggerKindToJSON(value?: TriggerKind | null): any {
    return value as any;
}

export function TriggerKindToJSONTyped(value: any, ignoreDiscriminator: boolean): TriggerKind {
    return value as TriggerKind;
}

